var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Footer } from '@/components/footer.component';
import { HearingAidCard, } from '@/components/hearing-aid-card.component';
import { NavigationButton } from '@/components/navigation-button.component';
import { Typography } from '@mui/material';
import { IconGoLiteLogo, IconGoPrimeLogo, IconLexieLogo, IconPoweredByBose, imageHearingAidsOverEar, imageHearingAidsInEar, } from 'hx-assets';
import { NavButtons } from 'hx-navigator';
import { FlexFlowLayout, StandardLayout } from 'hx-ui';
var hearingAids = [
    {
        headerImage: _jsx(IconGoLiteLogo, {}),
        name: 'Rechargeable OTC Hearing Aids',
        image: imageHearingAidsInEar,
        price: '$199',
        description: [
            'Nearly invisible design',
            'Adjustable volume',
            '60-day risk-free trial',
        ],
    },
    {
        headerImage: _jsx(IconLexieLogo, {}),
        name: 'Lexie B1 Self-fitting OTC Hearing Aids Powered by Bose',
        image: (_jsxs("div", __assign({ className: "flex items-center justify-center gap-4" }, { children: [_jsx("img", { src: imageHearingAidsOverEar, width: "85px", height: "72px", style: {
                        height: '100px',
                        position: 'relative',
                        top: '-6px',
                    }, alt: "Lexie B1 Hearing Aids Powered by Bose" }), _jsx(IconPoweredByBose, {})] }))),
        price: '$849',
        description: [
            'Self-fitting',
            'Small, behind-the-ear design',
            'Adjustable volume',
            'Replaceable batteries',
            '45-day risk-free trial',
            'Subscription plan available',
        ],
    },
    {
        headerImage: _jsx(IconGoPrimeLogo, {}),
        name: 'Rechargeable and Digital OTC Hearing Aids',
        image: imageHearingAidsInEar,
        price: '$299',
        description: [
            '100% Digital Processor (DSP)',
            '6 channels & 12 bands',
            '60-day risk-free trial',
        ],
    },
    {
        headerImage: _jsx(IconLexieLogo, {}),
        name: 'Lexie B2 Self-fitting OTC Hearing Aids Powered by Bose',
        image: (_jsxs("div", __assign({ className: "flex items-center justify-center gap-4" }, { children: [_jsx("img", { src: imageHearingAidsOverEar, width: "85px", height: "72px", style: {
                        height: '100px',
                        position: 'relative',
                        top: '-6px',
                    }, alt: "Lexie B1 Hearing Aids Powered by Bose" }), _jsx(IconPoweredByBose, {})] }))),
        price: '$999',
        description: [
            'Self-fitting',
            'Small, behind-the-ear design',
            'Adjustable volume',
            'Replaceable batteries',
            '45-day risk-free trial',
            'Subscription plan available',
        ],
    },
];
export var HearingAidOptionsPage = function () {
    return (_jsx(StandardLayout, { header: _jsx("div", __assign({ className: "grid px-4 py-8 place-items-center" }, { children: _jsx(Typography, __assign({ variant: "h2" }, { children: "Hearing Aid Options" })) })), content: _jsx(FlexFlowLayout, __assign({ className: "max-w-lg px-2 py-8 mx-auto sm:px-8" }, { children: hearingAids.map(function (hearingAid, index) { return (_jsx(HearingAidCard, { hearingAid: hearingAid }, "hearing-aid-card-".concat(index))); }) })), nav: _jsx(NavButtons, __assign({ col: true }, { children: _jsx(NavigationButton, __assign({ variant: "outlined", delta: -1, useDefaultClasses: false }, { children: "Back" })) })), footer: _jsx(Footer, {}) }));
};
